import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OneimgageModule } from 'app/common/component/oneimage/oneimage.module';
import { OnefileModule } from 'app/common/component/onefile/onefile.module';
import { AngularDateTimePickerModule } from 'angular2-datetimepicker';

import {
    Ftext,
    Fpassword,
    Fschooltext,
    Fdropdown,
    Ftextarea,
    FOneimage,
    FDate,
    FDateInput,
    FOnefile,
    Fschoollabel,
    Fmanyimages,
    Fcheckbox,
    FTime,
    FTime24,
    FItext,
    FIdropdown,
    FItextarea,
    FIDate
} from './fields';
import { ManyimagesModule } from '../component/manyimages/manyimages.module';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        OneimgageModule,
        OnefileModule,
        ManyimagesModule,
        AngularDateTimePickerModule,
    ],
    exports: [
        Ftext, Fpassword, Fschooltext, Fdropdown, Ftextarea, FOneimage, FDate, FDateInput, FOnefile, Fschoollabel, Fmanyimages, Fcheckbox, FTime, FTime24, FItext, FIdropdown, FItextarea, FIDate
    ],
    declarations: [
        Ftext, Fpassword, Fschooltext, Fdropdown, Ftextarea, FOneimage, FDate, FDateInput, FOnefile, Fschoollabel, Fmanyimages, Fcheckbox, FTime, FTime24, FItext, FIdropdown, FItextarea, FIDate
    ],
    providers: [
    ]
})

export class FieldModule { }



// WEBPACK FOOTER //
// ./src/app/common/fields/fields.module.ts